// theme
export interface ITheme {
	palette: {
		primary: string
		secondary: string
		accent: { light: string; dark: string; neutral: string }
	}
	spacing: {
		unit: number
	}
	blockType?: []
}

export default {
	palette: {
		primary: 'mediumseagreen',
		secondary: 'palevioletred',
		accent: {
			light: 'lightcoral',
			dark: 'indianred',
			neutral: 'lightgrey'
		}
	},
	spacing: {
		unit: 8
	}
}
